import { getV1, postV1, getV2, postV2, putV1, getGFT } from '@/common/utils/ajax'
import { DEFAULT_PER } from '@/config'

const getCallHistory = (params) => getV1(`consultant_call_histories`, params)

const setCallClientRemark = (id, params) => putV1(`consultant_call_histories/${id}/client_remark`, params)

const smsVerify = (mobile, sms_captcha) => postV1('sms_captchas/verify', {
    mobile,
    sms_captcha
})

const readSms = () => postV1('consultant_call_histories/read_all')

const getUserConsultants = () => getV2('consultants')

const selectCard = (consultant_id) => postV2(`consultants/${consultant_id}/master_card`)

const checkin = () => postV1('consultant_checkin')
const score_bonuses = () => postV1('consultant_checkin/score_bonuses')

const nationalday_checkin = () => postV1('activity_c/consultant_checkin')
const getNationalDayCheckin = () => getV1('activity_c/consultant_checkin')
const nationalday_score_bonuses = () => postV1('activity_c/consultant_checkin/score_bonuses')

const getTasks = () => getV1('consultant_task')

const getConsultantCheckins = () => getV1(`consultant_checkins`)

const getConsultantLikes = (params) => getV1(`likes`, params)

const getRanks = (params) => getV1('consultant_rankings', params)

const getConsultant = (params) => getV1('complainable_consultants', params)

const submitReport = (params) => postV1('consultant_resignations', params)

const getHotSearchList = () => getV1('view_rankings')

const consultantCheckinRankings = (params) => getV1('consultant_checkin_rankings', {
    per: DEFAULT_PER,
    ...params
})

const likeConsultant = (consultant_id) => postV1('consultant_card_likes', { consultant_id })

const weixinMomentsExamples = () => getV1('weixin_moments_examples')

const getCardLikes = (data) => getV1('consultant_card_likes', data)

const getConsultantReportYear =(params) => getGFT('v1/consultant_report/recent_year', params)
const getConsultantReportDaily =(params) => getGFT('v1/consultant_report/daily', params)
const getConsultantReportWeekly =(params) => getGFT('v1/consultant_report/weekly', params)

export default {
    getConsultantReportWeekly,
    getConsultantReportDaily,
    getConsultantReportYear,
    setCallClientRemark,
    getCallHistory,
    smsVerify,
    getUserConsultants,
    selectCard,
    checkin,
    readSms,
    score_bonuses,
    nationalday_checkin,
    nationalday_score_bonuses,
    getNationalDayCheckin,
    getTasks,
    getConsultantCheckins,
    getConsultantLikes,
    getRanks,
    getConsultant,
    submitReport,
    getHotSearchList,
    likeConsultant,
    getCardLikes,
    weixinMomentsExamples,
    consultantCheckinRankings
}
